import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { PendingBalanceRestore } from '../../utils/vacationBalanceDisplay';

export const VACATION_BALANCE_RESTORES_QUERY_KEY = 'vacationBalanceRestores';

function restoresKey(collaboratorId: string | undefined) {
    return [VACATION_BALANCE_RESTORES_QUERY_KEY, collaboratorId];
}

export function useVacationBalanceRestores(collaboratorId?: string): PendingBalanceRestore[] {
    const { data } = useQuery<PendingBalanceRestore[]>({
        queryKey: restoresKey(collaboratorId),
        queryFn: () => [],
        enabled: false,
        staleTime: Infinity,
    });

    return data ?? [];
}

export function registerBalanceRestore(
    queryClient: QueryClient,
    input: { collaboratorId: string; requestId: string; days: number }
): void {
    const restore: PendingBalanceRestore = {
        requestId: input.requestId,
        days: input.days,
        removedAtMs: Date.now(),
    };

    const key = restoresKey(input.collaboratorId);
    const withoutThisRequest = (current: PendingBalanceRestore[] = []) =>
        current.filter((item) => item.requestId !== input.requestId);

    queryClient.setQueryData<PendingBalanceRestore[]>(key, (current) => [
        ...withoutThisRequest(current),
        restore,
    ]);

    setTimeout(() => {
        queryClient.setQueryData<PendingBalanceRestore[]>(key, withoutThisRequest);
    }, 2 * 60 * 1000);
}
